import React from "react";
import "./App.css";
import Pages from "./Components/Pages";

import { Provider } from "react-redux";
// import { store } from "./store/store";

import { persistor, store } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';



function App() {


  return (

    <>
    <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
       <Pages />
       </PersistGate> 
    </Provider>
    </>
  );
}

export default App;


// http://preview.themeforest.net/item/cristiano-restaurant-wordpress-woocommerce-theme/full_screen_preview/17392139?_ga=2.142153659.825234749.1663410327-53095604.1663410327&_gac=1.19074572.1663410327.EAIaIQobChMI2Jv-o86b-gIVWAwrCh1KBAQ1EAAYAiAAEgIooPD_BwE
